import ActionSingleOrganization from "./ActionSingleOrganization/ActionSingleOrganization";
import AddNewCreateUserLinkFormModalOrga from "./AddNewCreateUserLinkFormModalBtn/AddNewCreateUserLinkFormModalBtn";
import CreateUserTokenListPresenter from "./CreateUserTokenList/CreateUserTokenListPresenter";
import OrganizationInfo from "./OrganizationInfo/OrganizationInfo";
import OrganizationLocation from "./OrganizationLocation/OrganizationLocation";

import OrganizationName from "./OrganizationName/OrganizationName";
import OrganizationUserList from "./OrganizationUserList/OrganizationUserList";

/**
 * SingleOrganization is a namespace that contains all the components related to a single organization.
 */
export const SingleOrganization = {
    CreateUserTokenList : CreateUserTokenListPresenter,
    Name: OrganizationName,
    AddNewCreateUserTokenModalBtn: AddNewCreateUserLinkFormModalOrga,
    Location: OrganizationLocation,
    ActionBtn: ActionSingleOrganization,
    Info: OrganizationInfo,
    UserList: OrganizationUserList
}

export default SingleOrganization;